export default "__VITE_ASSET__71dbdf90__"